import { ChartData } from "../../types";

export const generateTicks = (data: ChartData[], step: number): number[] => {
  const values = data.flatMap((d) =>
    [d.alpian, d.morningstarMarkets, d.morningstarCore].map(Number),
  );
  const min = Math.floor(Math.min(...values) / step) * step;
  const max = Math.ceil(Math.max(...values) / step) * step;

  const ticks = [];

  for (let i = min; i <= max; i += step) {
    ticks.push(i);
  }

  return ticks;
};

export const generateTicksFixed = (
  min: number,
  max: number,
  step: number,
): number[] => {
  const ticks = [];

  for (let i = min; i <= max; i += step) {
    ticks.push(i);
  }

  return ticks;
};

export const getRoundedYAxisDomain = (
  series: ChartData[],
): [number, number] => {
  const values = series.flatMap((item) => [
    item.alpian,
    item.morningstarMarkets,
    item.morningstarCore,
  ]);

  const rawMin = Math.min(...values);
  const rawMax = Math.max(...values);

  const roundedMin = Math.floor(rawMin / 10) * 10;
  const roundedMax = Math.ceil(rawMax / 10) * 10;

  return [roundedMin, roundedMax];
};
